/* Domain Black, liquid glass product cards.
   Gives each product card a heavily blurred copy of its own photo as the
   background behind the smoked glass. Re-runs when the grid re-renders
   (filters, sorting, pagination). */
(function () {
  function photoUrl(card) {
    var img = card.querySelector('.card__media img');
    if (!img) return '';
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src) return '';
    // A small version is enough once it is blurred, and loads fast
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', '360');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function paint(root) {
    var cards = (root || document).querySelectorAll('.card-wrapper .card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.dataset.dbBlur === '1') continue;
      var url = photoUrl(card);
      if (!url) continue;
      card.style.setProperty('--db-card-bg', 'url("' + url.replace(/"/g, '%22') + '")');
      card.classList.add('db-card--blurred');
      card.dataset.dbBlur = '1';
    }
  }

  function start() {
    paint(document);
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        paint(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
